import { useCallback, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';  // Update this import
import { useMediaQuery } from '@mui/material';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import LeadsDashboard from '../../components/Crm/Dashboard/LeadsDashboard';
import Lembretes from '../../components/Crm/Lembretes/Lembretes';
import EscalasSelection from '../../components/Crm/Escalas/EscalasSelection';
import LeadsDistribuicao from '../../components/Crm/Leads/LeadsDistribuicao';

import { getMyLeads, listLeadsDistribuidos } from '../../controllers/crm/leadController';
// import { leadStatus } from '../../constants/crm';
// import { getLeads } from '../../controllers/crm/leadController';
import { listenToCredito } from '../../controllers/userController';

import MenuIcon from '@mui/icons-material/Menu';
import AssessmentTwoToneIcon from '@mui/icons-material/AssessmentTwoTone';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import ShoppingCartCheckoutTwoToneIcon from '@mui/icons-material/ShoppingCartCheckoutTwoTone';
import SocialDistanceTwoToneIcon from '@mui/icons-material/SocialDistanceTwoTone';
import EmojiEmotionsTwoToneIcon from '@mui/icons-material/EmojiEmotionsTwoTone';
import BookmarksTwoToneIcon from '@mui/icons-material/BookmarksTwoTone';
import CalendarTodayTwoToneIcon from '@mui/icons-material/CalendarTodayTwoTone';
import AddIcCallTwoToneIcon from '@mui/icons-material/AddIcCallTwoTone';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ExitToAppTwoToneIcon from '@mui/icons-material/ExitToAppTwoTone';
import FolderSharedTwoToneIcon from '@mui/icons-material/FolderSharedTwoTone';
import MoveDownTwoToneIcon from '@mui/icons-material/MoveDownTwoTone';
import GroupAddTwoToneIcon from '@mui/icons-material/GroupAddTwoTone';
import AccountCircle from '@mui/icons-material/AccountCircle';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import GroupTwoToneIcon from '@mui/icons-material/GroupTwoTone';

import { CampanhaSelect } from '../../components/Crm/Campanhas/CampanhaSelect';
import ParticiparEscala from '../../components/Crm/Escalas/ParticiparEscala';
import MyLeads from '../../components/Crm/Leads/MyLeads';
import { MyTasks } from '../../components/Crm/Leads/MyTasks';
import { rules } from '../../constants/rules';
import { plans } from '../../constants/plans';

import dayjs from 'dayjs';
import { Alert, Fab, Menu, MenuItem, Snackbar, Stack } from '@mui/material';
import CarteiraSelecao from '../../components/Crm/Clientes/CarteiraSelecao';
import { canTeam } from '../../constants/perfil';
import { useEffect } from 'react';
import Equipe from '../../components/Equipe/Equipe';
import Perfil from '../../components/Perfil/Perfil';
import { MySnackBar } from '../../components/snackbar/Snackbar';
import { ConfirmationConvite } from '../../components/Convites/confirmInvite';
import { getOperador } from '../../controllers/crm/operadorController';
import LeadsControle from '../../components/Crm/Leads/LeadsControle';
import CorretorLeads from '../../components/Crm/Corretores/CorretorLeads';
import Tutorial from '../../components/Crm/Tutorial/Tutorial';
import HelpOutlineTwoToneIcon from '@mui/icons-material/HelpOutlineTwoTone';
import { red } from '@mui/material/colors';

// import { use } from 'react';



const drawerWidth = 240;
const drawerWidthReduced = 60; // Nova largura reduzida

function Home({ account, handleToHome, handleLogOut, setHasNewLead, coordinates, listen, disableAlertLead, update, setUpdate }) {

  const isAdmin = account.conta === account.id
  const [user, setUser] = useState(account);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(true);
  const [isClosing, setIsClosing] = useState(false);
  const [ativarTmp, setAtivarTmp] = useState(false)
  const [temporizador, setTemporizador] = useState(null)
  const [loading, setLoading] = useState(false)

  const [dayInicio, setDayInicio] = useState(dayjs().startOf('week').toISOString())
  const [dayFim, setDayFim] = useState(dayjs().endOf('week').toISOString())

  const [showControleOnLine, setShowControleOnLine] = useState(isAdmin ? true : false);
  const [showLeadsCampanha, setShowLeadsCampanha] = useState(false);
  const [showLeadsDistribuicao, setShowLeadsDistribuicao] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  const [showCarteira, setShowCarteira] = useState(false);
  const [showFluxo, setShowFluxo] = useState( false );

  const [showMyLeads, setShowMyLeads] = useState(isAdmin ? false : true);
  const [showLembretes, setShowLembretes] = useState(false);
  const [showMyTasks, setShowMyTasks] = useState(false);
  const [showOnLine, setShowOnLine] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);

  // Snackbar - Mensagens
  const [snackbar, setSnackbar] = useState(null)
  const handleCloseSnackbar = () => setSnackbar(null);

  // Cache de dados
  const [escalas, setEscalas] = useState([])
  const [escala, setEscala] = useState(null)

  const [dados, setDados] = useState(null)
  const [leadsList, setLeadsList] = useState([])
  const [leadsAll, setLeadsAll] = useState([])
  const [filteredLeads, setFilteredLeads] = useState([])
  const [reminders, setReminders] = useState([])
  const [tasks, setTasks] = useState([])
  const [openEquipe, setOpenEquipe] = useState(false)
  const [hasConvite, setHasConvite] = useState(user.hasinvite)
  const [openConvite, setOpenConvite] = useState(false)
  const [teamAnchoerEl, setTeamAnchorEl] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null);
  const [hasAvisos, setHasAvisos] = useState(false)
  const [msgAdm, setMsgAdm] = useState()
  const [operadores, setOperadores] = useState([])
  const [showCorretorLeads, setShowCorretorLeads] = useState(false);

  const [pathFlow, setPathFlow] = useState('/fluxoGS.gif')

  // Manutenção Convites
  const handleCloseInvetes = () => {
    setOpenConvite(false);
  };
  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    // if (!isClosing) {
    setMobileOpen(!mobileOpen);
    // }
  };


  // Load Functions
  // Load MyLeads
  const loadMyLeads = useCallback(async () => {
    setLoading(true)
    try {
      const api = await getMyLeads(user)
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('MyLeads', api)
      if (api.status === 200) {
        // setUpdate(false)
        if (api.data.length > 0) {
          // console.log('MyLeads', api.data)
          setLeadsList(api.data)
          setFilteredLeads(api.data)
          // setDados(estatistica(api.data))
        }
        else {
          setLeadsList([])
          setFilteredLeads([])
          setDados(null)
        }
      }
      else {
        setLeadsList([])
        setFilteredLeads([])
        setDados(null)
      }
    } catch (e) {
      // console.log('Error', e)
      setSnackbar({ message: 'Erro ao carregar Leads', severity: 'error' })
    }
    finally {
      setLoading(false)
    }
  }, [user, setFilteredLeads, setLeadsList, setLoading, setSnackbar])

  // Load All Operadores
  async function loadAllOperadores() {
    if (operadores.length > 0) return;
    setLoading(true)
    const query = {
      where: {
        idconta: user.conta,
        isactive: true,
      },
      select: {
        idoperador: true,
        nome: true,
      }
    }
    try {
      const api = await getOperador(query)
      if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('Operadores', api)
      if (api.status === 200) {
        if (api.data.length > 0) {
          // console.log('Operadores', api.data)
          setOperadores(api.data)
        }
        else {
          setOperadores([])
        }
      }
      else {
        setOperadores([])
      }
    } catch (e) {
      console.log('Error', e)
      setOperadores([])
    }
    finally {
      setLoading(false)
    }
  }

  // Load All Leads
  async function loadAllLeads() {
    setLoading(true)
    try {
      const api = await listLeadsDistribuidos(user)
      if (api.status === 200) {
        if (api.data.length > 0) {
          // console.log('Leads Distribuidos', api.data);
          setLeadsAll(api.data);
        }
        else {
          setLeadsAll([])
        }
      }
      else {
        setLeadsAll([])
      }
    } catch (e) {

    }
    finally {
      setLoading(false)
    }
  }


  
  const menu = ['Escala OnLine', 'Leads Campanha', 'Leads Distribuição', 'Leads Corretor', 'Dashboard']
  const menu2 = ['Leads', 'Lembretes', 'Tarefas', 'Participar OnLine', 'Dashboard', 'Carteira', 'Imóveis', 'Fluxo', 'LogOut']
  // se for Admin, retira o 'Dashboard' do menu2
  if (isAdmin) {
    menu2.splice(4, 1)
  }

  const [tituloPage, setTituloPage] = useState(isAdmin ? menu[0] : menu2[0]);

  const selectOption = (option) => {
    if (option !== 'Escala OnLine' && showControleOnLine) { setShowControleOnLine(false); }
    if (option !== 'Leads Campanha' && showLeadsCampanha) { setShowLeadsCampanha(false); }
    if (option !== 'Leads Distribuição' && showLeadsDistribuicao) { setShowLeadsDistribuicao(false); }
    if (option !== 'Leads Corretor' && showCorretorLeads) { setShowCorretorLeads(false); }
    if (option !== 'Dashboard' && showDashboard) { setShowDashboard(false); }
    if (option !== 'Carteira' && showCarteira) { setShowCarteira(false); }
    if (option !== 'Leads' && showMyLeads) { setShowMyLeads(false); }
    if (option !== 'Lembretes' && showLembretes) { setShowLembretes(false); }
    if (option !== 'Tarefas' && showMyTasks) { setShowMyTasks(false); }
    if (option !== 'Participar OnLine' && showOnLine) { setShowOnLine(false); }
    if (option !== 'Tutorial' && showTutorial) { setShowTutorial(false); }
    if (option !== 'Fluxo' && showFluxo) { setShowFluxo(false); }
    switch (option) {
      case 'Escala OnLine':
        // showControleOnLine ? setShowControleOnLine(false) : 
        setShowControleOnLine(true)
        setTituloPage(menu[0])
        break;
      case 'Leads Campanha':
        // showLeadsCampanha ? setShowLeadsCampanha(false) : 
        setShowLeadsCampanha(true)
        setTituloPage(menu[1])
        break;
      case 'Leads Distribuição':
        // showLeadsDistribuicao ? setShowLeadsDistribuicao(false) : 
        setShowLeadsDistribuicao(true)
        setTituloPage(menu[2])
        break;
      case 'Leads Corretor':
        setShowCorretorLeads(true);
        setTituloPage(menu[3]);
        break;
      case 'Dashboard':
        // showDashboard ? setShowDashboard(false) : 
        setShowDashboard(true)
        setTituloPage(menu[4])
        break;
      case 'Leads':
        // showMyLeads ? setShowMyLeads(false) :
        setShowMyLeads(true)
        setTituloPage(menu2[0])
        break;
      case 'Lembretes':
        // showLembretes ? setShowLembretes(false) : 
        setShowLembretes(true)
        setTituloPage(menu2[1])
        break;
      case 'Tarefas':
        // showMyTasks ? setShowMyTasks(false) : 
        setShowMyTasks(true)
        setTituloPage(menu2[2])
        break;
      case 'Participar OnLine':
        // showOnLine ? setShowOnLine(false) : 
        setShowOnLine(true)
        setTituloPage(menu2[3])
        break;
      case 'Carteira':
        // showCarteira ? setShowCarteira(false) :
        setShowCarteira(true)
        isAdmin ? setTituloPage(menu2[4]) : setTituloPage(menu2[5])
        break;
      case 'Imóveis':
        handleToHome()
        break;
      case 'Tutorial':
        setShowTutorial(!showTutorial)
        setTituloPage(menu2[6])
        break;
      case 'LogOut':
        handleLogOut()
        break;
      case 'Fluxo':
        setShowFluxo(!showFluxo)
        isAdmin ? setTituloPage(menu2[6]) : setTituloPage(menu2[7])
        break;
      default:
        break;
    }
    handleDrawerClose()
  }

  // state para hover do drawer (expande quando passa o mouse)
  const [drawerHover, setDrawerHover] = useState(false);

  // Calcular largura do drawer baseado no estado
  const currentDrawerWidth = (!isMobile && showMyLeads) ? (drawerHover ? drawerWidth : drawerWidthReduced) : drawerWidth;

  const drawer = (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === 'light'
          ? theme.palette.primary.main
          : theme.palette.background.paper,
        height: 'auto',
        overflow: 'clip',
        color: theme.palette.primary.contrastText,
        transition: 'all 0.3s ease',
        '& .MuiListItemButton-root': {
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: `${theme.palette.primary.light} !important`,
            transform: 'translateX(4px)',
            '& .MuiListItemIcon-root, & .MuiListItemText-root': {
              color: theme.palette.primary.contrastText
            }
          }
        },
        '& .MuiDivider-root': {
          borderColor: 'rgba(255, 255, 255, 0.12)'
        }
      }}
    >
      {/* Logotipo */}
      <Box
        my={1.3}
        mx={currentDrawerWidth === drawerWidth ? 3 : 'auto'}
        height={'45px'}
        width={currentDrawerWidth === drawerWidth ? '139px' : '40px'}
        sx={{
          display: { xs: 'flex', md: 'flex' },
          backgroundImage: currentDrawerWidth === drawerWidth 
            ? 'url(./logo1n_bc.png)' 
            : 'url(./logo2_bc.svg)', // Crie um ícone menor/simplificado
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          transition: 'all 0.3s ease',
        }}
      />
      {/* Drawer Content */}
      {(user.rules.includes(rules.ruleAdm.title) &&
        user.plano.toLowerCase() !== plans.planUser.title.toLowerCase()) && (
          <>
            <Divider sx={{ borderColor: theme.palette.divider }} />
            <List>
              {menu.map((text) => (
                <ListItem key={text} disablePadding>
                  <ListItemButton
                    onClick={() => selectOption(text)}
                    sx={{
                      py: 1.5,
                      justifyContent: currentDrawerWidth === drawerWidthReduced ? 'center' : 'flex-start',
                      '& .MuiListItemIcon-root': {
                        color: theme.palette.primary.contrastText,
                        minWidth: currentDrawerWidth === drawerWidthReduced ? 'auto' : 40,
                      },
                      '& .MuiListItemText-root': {
                        color: theme.palette.primary.contrastText,
                        '& .MuiTypography-root': {
                          fontWeight: 500
                        }
                      }
                    }}
                  >
                    <ListItemIcon sx={{ color: theme.palette.primary.contrastText }}>
                      {text === 'Dashboard' && <AssessmentTwoToneIcon />}
                      {text === 'Escala OnLine' && <CalendarMonthTwoToneIcon />}
                      {text === 'Leads Campanha' && <ShoppingCartCheckoutTwoToneIcon />}
                      {text === 'Leads Distribuição' && <SocialDistanceTwoToneIcon />}
                      {text === 'Leads Corretor' && <GroupTwoToneIcon />}
                    </ListItemIcon>
                    {currentDrawerWidth === drawerWidth && (
                      <ListItemText
                        primary={text}
                        sx={{
                          color: theme.palette.primary.contrastText,
                          '& .MuiTypography-root': {
                            fontWeight: 500
                          }
                        }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </>
        )}
      <Divider sx={{ borderColor: theme.palette.divider }} />
      {/* Menu2 List */}
      <List>
        {menu2.map((text) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              onClick={() => selectOption(text)}
              sx={{
                py: 1.5,
                justifyContent: currentDrawerWidth === drawerWidthReduced ? 'center' : 'flex-start',
                '& .MuiListItemIcon-root': {
                  color: theme.palette.primary.contrastText,
                  minWidth: currentDrawerWidth === drawerWidthReduced ? 'auto' : 40
                },
                '& .MuiListItemText-root': {
                  color: theme.palette.primary.contrastText,
                  '& .MuiTypography-root': {
                    fontWeight: 500
                  }
                }
              }}
            >
              <ListItemIcon sx={{ color: theme.palette.primary.contrastText }}>
                {text === 'Carteira' && <FolderSharedTwoToneIcon />}
                {text === 'Leads' && <EmojiEmotionsTwoToneIcon />}
                {text === 'Lembretes' && <BookmarksTwoToneIcon />}
                {text === 'Tarefas' && <CalendarTodayTwoToneIcon />}
                {text === 'Participar OnLine' && <AddIcCallTwoToneIcon />}
                {text === 'Imóveis' && <MapsHomeWorkIcon />}
                {text === 'Tutorial' && <HelpOutlineTwoToneIcon />}
                {text === 'LogOut' && <ExitToAppTwoToneIcon />}
                {text === 'Fluxo' && <MoveDownTwoToneIcon />}
                {text === 'Dashboard' && <AssessmentTwoToneIcon />}
              </ListItemIcon>
              {currentDrawerWidth === drawerWidth && (
                <ListItemText
                  primary={text}
                  sx={{
                    color: theme.palette.primary.contrastText,
                    '& .MuiTypography-root': {
                      fontWeight: 500
                    }
                  }}
                />
              )}
            </ListItemButton>
          </ListItem>
        ))
        }
      </List>
    </Box>
  );

  const handleCreditoUpdate = (result) => {
    if (result.success) {
      user.credito = result.credito
    } else {
      setSnackbar({ open: true, message: result.message, severity: 'error' });
    }
  };

  useEffect(() => {
    if (!user.sawtheflow) user.sawtheflow = true

    const subscription = listenToCredito(user, handleCreditoUpdate)
    return () => subscription();
  }, [])

  useEffect(() => {
    loadAllLeads()
    loadMyLeads()
    loadAllOperadores()
  }, [update])

  const handlerOpenEquipe = () => {
    setOpenEquipe(!openEquipe)
    handleTeamMenuClose()
  }
  const handleTeamMenuClose = () => {
    setTeamAnchorEl(null);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    // handleMobileMenuClose();
  };
  const [openPerfil, setOpenPerfil] = useState(false)
  const handleOpenPerfil = () => {
    setOpenPerfil(true)
    setAnchorEl(null);
  }
  const isMenuOpen = Boolean(anchorEl);
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      id='menuPerfil'
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>{'Usuário: ' + user.email}</MenuItem>
      {user.conta !== user.id && (<MenuItem onClick={handleMenuClose}>{'Equipe: ' + user.equipe}</MenuItem>)}
      <MenuItem onClick={handleMenuClose}>{'Plano: ' + user.plano}</MenuItem>
      <MenuItem onClick={handleOpenPerfil} >Minha Conta</MenuItem>
    </Menu>
  );

  // Constantes do MySnackBar
  const [msg, setMsg] = useState('')
  const [openSnack, setOpenSnack] = useState(false)
  const [tmp, setTMP] = useState(6000)
  const [severity, setSeverity] = useState('info')

  function showMySnackbar(_msg, _tmp, _severity) {
    setMsg(_msg)
    setTMP(_tmp)
    setSeverity(_severity)
    setOpenSnack(true)
  }

  return (
    <Box sx={{
      display: 'flex',
    }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${currentDrawerWidth}px)` },
          ml: { sm: `${currentDrawerWidth}px` },
          transition: 'all 0.3s ease',
        }}
      >
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <Typography variant="h3" noWrap component="div">
              Gestão de Leads - {tituloPage}
            </Typography>
            {/* Icone do menu para alerta de lead } */}
            {listen &&
              <IconButton
                size="medium"
                edge="end"
                aria-label="Lead"
                color='error'
                onClick={disableAlertLead}
                className={'btn-pisca'}
              >
                <CampaignOutlinedIcon fontSize='large' /> Lead
              </IconButton>
            }

            <Stack direction="row" spacing={{ xs: 0, md: 2 }} alignItems="center">
              {/* Icone do Menu para Administrar Imóveis  } */}
              <IconButton size="large"
                // aria-label="Imóveis"
                title='Imóveis'
                color="inherit"
                onClick={handleToHome}
              >
                <MapsHomeWorkIcon fontSize='large' />
              </IconButton>
              {/* Icone do Menu para Administrar Equipes} */}
              {canTeam(user) && (
                <IconButton
                  size="large"
                  hidden={true}
                  aria-label="Equipe"
                  title="Equipe"
                  onClick={() => { setOpenEquipe(!openEquipe) }}
                  color="inherit"
                >
                  <GroupAddTwoToneIcon fontSize='large' />
                </IconButton>
              )}
              {/* Icone do Menu para Perfil do Usuário */}
              <IconButton
                size="large"
                // aria-label="Perfil do usuário"
                title="Perfil do usuário"
                color="inherit"
                onClick={handleProfileMenuOpen}
              >
                <AccountCircle fontSize='large' />
              </IconButton>
              {/* Icone do Menu para administrar Convites} */}
              {user.hasinvite && (
                <IconButton
                  size="large"
                  title='Convites'
                  onClick={() => { setOpenConvite(true) }}
                  color="error"
                  className='btn-pisca'
                >
                  <EmailTwoToneIcon fontSize='large' />
                </IconButton>
              )}
              {/* Icone do Menu para LogOut} */}
              <IconButton size="large"
                aria-label="sair"
                color="inherit"
                onClick={handleLogOut}
              >
                <ExitToAppTwoToneIcon fontSize='large' />
              </IconButton>
            </Stack>
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              display: { sm: 'none' }
            }}
          >
            <MenuIcon fontSize='large' />
          </IconButton> */}
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{
          width: { sm: currentDrawerWidth },
          flexShrink: { sm: 0 },
          transition: 'all 0.3s ease',
        }}
        aria-label="menu"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={document.body}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
            disablePortal: true,
            disableEnforceFocus: false,
            disableRestoreFocus: false
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: theme.palette.primary.main,
              transition: 'all 0.3s ease',
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          PaperProps={{
            onMouseEnter: () => setDrawerHover(true),
            onMouseLeave: () => setDrawerHover(false),
            sx: {
              boxSizing: 'border-box',
              width: currentDrawerWidth,
              backgroundColor: theme.palette.primary.main,
              transition: 'all 0.3s ease',
            }
          }}
          sx={{ display: { xs: 'none', sm: 'block' } }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={
          {
            pt: 6,
            flexGrow: 1,
            width: { xs: '100vw', sm: `calc(100vw - ${currentDrawerWidth}px)` },
            height: `calc(100vh - 60px)`,
            justifyItems: 'center',
            bgcolor: red[50],
            overflow: 'auto',
            paddingTop: 3,
            // m: 0,
            transition: 'all 0.3s ease',
          }
        }
      >
        {/* <Toolbar /> */}
        <Fab
          color="primary"
          aria-label="add"
          onClick={handleDrawerToggle}
          sx={{
            position: 'absolute',
            left: '6dvw',
            bottom: '2dvh',
            zIndex: 1100,
            display: { xs: 'flex', md: 'none' }
          }}
        >
          <MenuIcon />
        </Fab>
        {showFluxo && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              width: '100%',
              p: 2,
            }}
          >
            <img
              src={pathFlow}
              alt="Fluxo GIMOV"
              onClick={() => setPathFlow(pathFlow === '/fluxoGS.gif' ? '/fluxoGP.gif' : '/fluxoGS.gif')}
              style={{
                height: 'auto',
                width: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            />
          </Box>
        )}
        {showControleOnLine &&
          <EscalasSelection
            account={account}
            setEscalas={setEscalas}
            escalas={escalas}
            setEscala={setEscala}
            escala={escala}
          />
        }
        {showLeadsCampanha &&
          <CampanhaSelect
            user={user}
            setSnackbar={setSnackbar}
            setLoading={setLoading}
            loading={loading}
          />}
        {showLeadsDistribuicao &&
          <LeadsDistribuicao
            account={account}
            setUpdate={setUpdate}
            setSnackbar={setSnackbar}
            listen={listen}
          />
        }
        {showCorretorLeads &&
          <CorretorLeads
            idconta={account.conta}
            setUpdate={setUpdate}
            setSnackbar={setSnackbar}
            listen={listen}
            corretorView={true}
          />
        }
        {showDashboard &&
          <LeadsDashboard
            account={account}
            setLeadsAll={setLeadsAll}
            leadsAll={leadsAll}
            update={update}
            setUpdate={setUpdate}
            setAtivarTmp={setAtivarTmp}
            ativarTmp={ativarTmp}
            temporizador={temporizador}
            setTemporizador={setTemporizador}
            loadAllLeads={loadAllLeads}
            operadores={operadores}
            setOperadores={setOperadores}
          />
        }
        {showCarteira &&
          <CarteiraSelecao
            account={account}
            setSnackbar={setSnackbar}
          />
        }
        {showMyLeads && (
          isMobile ? (
            <MyLeads
              account={account}
              leadsList={leadsList}
              setLeadsList={setLeadsList}
              filteredLeads={filteredLeads}
              setFilteredLeads={setFilteredLeads}
              setSnackbar={setSnackbar}
              showMyLeads={showMyLeads}
              setShowMyLeads={setShowMyLeads}
              setUpdate={setUpdate}
              update={update}
              loadMyLeads={loadMyLeads}
              loading={loading}
              setLoading={setLoading}
            />
          ) : (
            <Box sx={{ width: '100%', height: '100%', p: 0 }}>
              <LeadsControle
                account={account}
                setSnackbar={setSnackbar}
                setUpdate={setUpdate}
                update={update}
              />
            </Box>
          )
        )}
        {showLembretes &&
          <Lembretes
            account={account}
            setSnackbar={setSnackbar}
            setShowReminders={setShowLembretes}
            reminders={reminders}
            setReminders={setReminders}
            setUpdate={setUpdate}
            update={update}
          />
        }
        {showMyTasks &&
          <MyTasks
            account={account}
            setSnackbar={setSnackbar}
            // setShowTasks={setShowTasks}
            tasks={tasks}
            setTasks={setTasks}
            setUpdate={setUpdate}
            update={update}
            // setShowMenu={setShowMenu}
            dayInicio={dayInicio}
            dayFim={dayFim}
            setDayInicio={setDayInicio}
            setDayFim={setDayFim}
          />
        }
        {showOnLine &&
          <ParticiparEscala
            account={account}
            setSnackbar={setSnackbar}
            snackbar={snackbar}
            setUpdate={setUpdate}
            update={update}

          />
        }
        {showTutorial &&
          <Tutorial user={user} />
        }
      </Box>
      {/*Mostra formulário de Manutenção de Equipe */}
      {openEquipe && (
        <Equipe user={account} openEquipe={openEquipe} setOpenEquipe={setOpenEquipe}
          setHasMessage={setHasAvisos} setMsgAdm={setMsgAdm} msgAdm={msgAdm} />
      )}
      {(openPerfil) && (
        <Perfil
          user={account}
          openPerfil={openPerfil}
          setOpenPerfil={setOpenPerfil}
          setUser={setUser}
          showMySnackbar={showMySnackbar}
        />
      )}
      {openConvite && (
        <ConfirmationConvite
          id="convites"
          keepMounted
          onClose={handleCloseInvetes}
          open={openConvite}
          user={user}
        />
      )}
      {!!snackbar && (
        <Snackbar
          open
          onClose={handleCloseSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom'
          }}
        >
          <Alert
            {...snackbar}
            onClose={handleCloseSnackbar}
            variant="filled"
            elevation={6}
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      )}
      {renderMenu}
      {/* Mensagens do Sistemas */}
      <MySnackBar open={openSnack} msg={msg} tmp={tmp} severity={severity} setOpenSnack={setOpenSnack} />
    </Box>
  );
}


export default Home;
